import { createContext } from 'react';
import { HeaderWithIconProps } from '../../general/header/HeaderWithIcon';
import { FirestoreUser, Invitation } from 'generated/graphql';

export type UsersContextType = {
    removeUser: (userId: string) => void;
    removeInvitation: (invitationId: string) => void;
    searchFilters: any[];
    searchInput: string;
    setSearchInput: React.Dispatch<React.SetStateAction<string>>;
    handleOnSearchBarChange: (chips: string[]) => void;
    usersTable: FirestoreUser[];
    invitationsTable: Invitation[];
    users: FirestoreUser[];
    invitations: Invitation[];
    header: HeaderWithIconProps;
    setHeader: React.Dispatch<React.SetStateAction<HeaderWithIconProps>>;
    addInvitation: (newInvitation: Invitation[]) => void;
    loadingUsers: boolean;
    loadingInvites: boolean;
};

const UserContext = createContext<UsersContextType | null>(null);

export default UserContext;
